import React, { Component } from "react";
import styled from "styled-components";
import Constants from "../Domain/constants";
import * as L from "../Utils/Lang";

const FacebookLogo =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfhBwoKADWXdR8GAAAB7UlEQVRo3u2ZPUtcQRSGnzNYCKm8hQQLKyGkEhHZLcLWFmmSVNsFUmojFhbp/QE2FvkF619IsLDaZSFfkI8iRVYESZEriItI0GOxitndSbx3ZrxjMW85d957njNzZ+YyR/hLmtGgTo0lHhBefbp0aLMnufW5NjXXKpRrczx4pq1Kgl+rpdkgslwN/Qdm72DQ/6d9FiQHA8B25eFhlu2buY+lJohm/GCq8vwHOmLO0IgWHqZoGOrRwgPUDbWoADXRkzvZ9YqqL6qBX/mHd3xln+OR9ie8svYPuqxOdUOn7Vz60m6ZCJh7j+fyvqzJBAv/lsXy4cMBvGFZfrsYwwAcsCYXbtYwAOvSd7WGANiVHXezP8A5qz52f4Av8i0uwCc/u/9G9Hm8SWfY4mmxVP0BbCPwmhdF7f6H0UP5NZK/cMBMZQAioy06yWlxf7izwFEJoPwqeMb3W3qc8djq2wwD8FNuARC1IeqhvXf0KUgACSABRAcovxE9Gj4+5eNoBxXmLb5/XAKl4zgBJIAEkAASwD0AcL7dCaK+oRsVoGvoRAXoGNpRAdreJRuvH5Ij5ozkrETLf+WqhupTtBx/q04WtLZuLJn2KgfoDWqnBkByFvC4bnXQzqBuOkzuVLx2GIGh4vXQN+xSvi+xCqzl+0tKfT0KspeCNQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0wNy0xMFQxMDowMDo1MyswMjowMJw2HIMAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMDctMTBUMTA6MDA6NTMrMDI6MDDta6Q/AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==";
const GoogleLogo =
  "data:image/png;base64,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";

const ButtonWrapper = styled.a`
  padding: 10px;
  border-radius: 5px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0px 0px 0px 10px;

  ${props => props.css}

  @media screen and (max-width: 380px) {
    margin: 10px 0px 0px 0px;
  }
`;

const Icon = styled.img`
  width: 25px;
  height: 25px;
  ${props => props.css}
`;

class FacebookLoginButton extends Component {
  render() {
    let { pathname = "", css = "" } = this.props;
    return (
      <ButtonWrapper
        href={`${Constants.apiUrl}/auth/facebook?redirect_url=${Constants.webUrl}${pathname}`}
        css={`
          flex: 1;
          background-color: #475993;
          color: white;
          ${css}
        `}
      >
        <Icon src={FacebookLogo} css="margin-right: 8px;" />
        <span>{L.s("log-in-with-facebook")}</span>
      </ButtonWrapper>
    );
  }
}

class GoogleLoginButton extends Component {
  render() {
    let { pathname = "", css = "" } = this.props;
    return (
      <ButtonWrapper
        href={`${Constants.apiUrl}/auth/google?redirect_url=${Constants.webUrl}${pathname}`}
        css={`
          flex: 1;
          background-color: white;
          color: grey;
          border: 1px solid grey;
          ${css}
        `}
      >
        <Icon src={GoogleLogo} css="margin-right: 8px;" />
        <span>{L.s("log-in-with-google")}</span>
      </ButtonWrapper>
    );
  }
}

export { FacebookLoginButton, GoogleLoginButton };
